/** @file removeNode: asks, then removes one node (children move to its parent) and clears the selection. */
import type { EditorStore } from '../../state/editorTypes';

/** Dispatches `node.remove { name }` after `confirm` says yes; returns whether it dispatched. */
export function removeNode(store: EditorStore, name: string, confirm: (text: string) => boolean): boolean {
  if (!confirm(`Remove node "${name}"? Its children move to its parent.`)) return false;
  const s = store.getState();
  void s.dispatch([{ name: 'node.remove', input: { name, children: 'reparent' } }], `remove ${name}`);
  s.select({ nodes: s.selection.nodes.filter((n) => n !== name), drawable: null });
  return true;
}
